import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, PortalLocation, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAddQuoteStop extends Layout {
    buttonDelete: Button;
    checkboxApptRequired: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelStopType: Label;
    locationStop: PortalLocation;
    panel1: Panel;
    panel5: Panel;
    panelDateTimes: Panel;
    panelDates: Panel;
    panelLoc: Panel;
    panelStopRow: Panel;
    sourceQuoteStop: DataSource;
    switchStopType: Switch;
    textPickupDate: Textbox;
    textboxContactName: Textbox;
    textboxEarlyPickup: Textbox;
    textboxPhone: Textbox;
}
